module.exports = __webpack_public_path__ + "static/media/downloadIcon.f7bd3522.svg";